import data from './data';

/*****************************************
 * EXPORTED FUNCTIONS
 *****************************************/

const calcFunctions = {
  initRec,
  calcInit0,
  calcInit1,
  calcInit2,
  calcInit3,
};

export default calcFunctions;

/*****************************************
 * CALCULATIONS
 *****************************************/

// all variables are declares in data.js

function initRec() {
  for (let i = 0; i < data.rowSize; i++) {
    data.Xcor[i] = Array(data.colSize).fill(-1);
    data.Ycor[i] = Array(data.colSize).fill(-1);
  }
  // init rectrangle
  data.Xcor[0][0] = 0;
  data.Ycor[0][0] = 0;
  data.Xcor[1][0] = 0;
  data.Ycor[1][0] = 100;
  data.Xcor[2][0] = 100;
  data.Ycor[2][0] = 100;
  data.Xcor[3][0] = 100;
  data.Ycor[3][0] = 0;
}

function fillRec(coe) {
  // console.log(coe)
  let activeDot = 2;
  for (let j = 1; j < data.colSize; j++) {
    // colSize = 4 for first iteration, 8 at second
    activeDot *= 2; // start with 4 dots, then 8, 16...
    for (let i = 0; i < activeDot; i++) {
      let prevDot = (i + activeDot - 1) % activeDot; // cyclic references
      let currentDot = i;
      let nextDot = (i + 1) % activeDot;

      data.Xcor[2 * i][j] =
        data.Xcor[prevDot][j - 1] * coe[0][0] +
        data.Xcor[currentDot][j - 1] * coe[0][1] +
        data.Xcor[nextDot][j - 1] * coe[0][2];
      data.Xcor[2 * i + 1][j] =
        data.Xcor[prevDot][j - 1] * coe[1][0] +
        data.Xcor[currentDot][j - 1] * coe[1][1] +
        data.Xcor[nextDot][j - 1] * coe[1][2];

      data.Ycor[2 * i][j] =
        data.Ycor[prevDot][j - 1] * coe[0][0] +
        data.Ycor[currentDot][j - 1] * coe[0][1] +
        data.Ycor[nextDot][j - 1] * coe[0][2];
      data.Ycor[2 * i + 1][j] =
        data.Ycor[prevDot][j - 1] * coe[1][0] +
        data.Ycor[currentDot][j - 1] * coe[1][1] +
        data.Ycor[nextDot][j - 1] * coe[1][2];
    }
  }
}


// initializations

function calcInit0(coe) {
  // init rectangle
  data.Xcor[0][0] = 0;
  data.Ycor[0][0] = 20;
  data.Xcor[1][0] = 0;
  data.Ycor[1][0] = 80;
  data.Xcor[2][0] = 100;
  data.Ycor[2][0] = 80;
  data.Xcor[3][0] = 100;
  data.Ycor[3][0] = 20;
  // console.log('[DRAW0]');
  fillRec(coe);
}

/********************************************************** */
// fill for other examples
/********************************************************* */
function calcInit2(coe) {
  // init rectangle
  data.Xcor[0][0] = 0;
  data.Ycor[0][0] = 20;
  data.Xcor[1][0] = 0;
  data.Ycor[1][0] = 80;
  data.Xcor[2][0] = 25;
  data.Ycor[2][0] = 25;
  data.Xcor[3][0] = 100;
  data.Ycor[3][0] = 20;
  fillRec(coe);
}
function calcInit1(coe) {
  data.Xcor[0][0] = 0;
  data.Ycor[0][0] = 20;
  data.Xcor[1][0] = 0;
  data.Ycor[1][0] = 80;
  data.Xcor[2][0] = 50;
  data.Ycor[2][0] = 80;
  data.Xcor[3][0] = 100;
  data.Ycor[3][0] = 20;
  fillRec(coe);
}
function calcInit3(coe) {
  data.Xcor[0][0] = 0;
  data.Ycor[0][0] = 0;
  data.Xcor[1][0] = 0;
  data.Ycor[1][0] = 100;
  data.Xcor[2][0] = 50;
  data.Ycor[2][0] = 100;
  data.Xcor[3][0] = 100;
  data.Ycor[3][0] = 0;
  fillRec(coe);
}

